

 export const AllItems = [
    {
      id:1,
      url:"1.jpg",
      mealName:"كيلو ديك رومي",
      details:"  بالاضافه لرز وعيش وسلطه وطحينه",
      price:"80",
      category:"عروض"
    },
    {
      id:2,
      url:"2.jpg",
      mealName:"ورك رومي",
      details:"حجم متوسط بالاضافه لرز  وسلطه وطحينه",
      price:"240",
      category:"عروض"
    },   
    {
      id:3,
      url:"3.jpg",
      mealName:"دبوس رومي",
      details:" بالاضافه لرز  وسلطه وطحينه",
      price:"90",
      category:"عروض"
    },     
    {
      id:4,
      url:"4.jpg",
      mealName:" ماعز",
      details:`بحد ادنى ربع جدي "بالحجز"`,
      price:"230",
      category:"عروض"
    }, 
     {
      id:5,
      url:"5.jpg",
      mealName:" وجيه لحم ماعز",
      details:`مع ارز وسلطات`,
      price:"115",
      category:"عروض"
    },  
    {
      id:6,
      url:"66.jpg",
      mealName:"بطه ماندي",
      details:"محشي ارز بالخلطه",
      price:"170",
      category:"عروص"
    },    
    {
      id:7,
      url:"7.jpg",
      mealName:"فرخه ماندي",
      details:"اضافه ارز ",
      price:"100",
      category:"عروص"
    },   
    {
      id:8,
      url:"8.jpg",
      mealName:"حمام ",
      details:" فرد محشي ارز ",
      price:"100",
      category:"عروص"
    },    
    {
      id:9,
      url:"9.jpg",
      mealName:"كيلو كباب بتلو",
      details:" بالاضافه سلطه وعيش وطحينه ",
      price:"300",
      category:"مشويات"
    },    
    {
      id:10,
      url:"10.jpg",
      mealName:"كيلو كباب ضاني",
      details:" بالاضافه سلطه وعيش وطحينه ",
      price:"300",
      category:"مشويات"
    },    
    {
      id:11,
      url:"11.jpg",
      mealName:"كيلو  طرب",
      details:" بالاضافه سلطه وعيش وطحينه ",
      price:"220",
      category:"مشويات"
    },    
    {
      id:12,
      url:"12.jpg",
      mealName:"طبق مشويات ميكس",
      details:" بالاضافه سلطه وعيش وطحينه ",
      price:"140",
      category:"مشويات"
    },    
    {
      id:13,
      url:"13.jpg",
      mealName:"فرخه شيش",
      details:" بالاضافه سلطه وعيش وطحينه ",
      price:"100",
      category:"مشويات"
    },    
    {
      id:14,
      url:"14.jpg",
      mealName:" مكرونه ميكسيكي",
      details:" حجم متوسط",
      price:"25",
      category:"اضافات ومعجنات"
    },
    {
      id:15,
      url:"15.jpg",
      mealName:" مكرونه بولونيز",
      details:" باللحمه المفرومه حجم متوسط",
      price:"30",
      category:"اضافات ومعجنات"
    },
    {
      id:16,
      url:"16.jpg",
      mealName:" مكرونه نجرسكو",
      details:"   حجم متوسط",
      price:"40",
      category:"اضافات ومعجنات"
    },
    {
      id:17,
      url:"17.jpg",
      mealName:" مكرونه بشايل",
      details:"   حجم متوسط",
      price:"20",
      category:"اضافات ومعجنات"
    },    
    {
      id:18,
      url:"18.jpg",
      mealName:"  ربع مندي + تمن كفته",
      details:"اضافه ارز وسلطه",
      price:"45",
      category:"وجبات"
    },    
    {
      id:19,
      url:"19.jpg",
      mealName:"  ربع فرخه + تمن كفته",
      details:"اضافه ارز وسلطه",
      price:"75",
      category:"وجبات"
    },    
    {
      id:20,
      url:"1.jpg",
      mealName:"وجبة حمام",
      details:"اتنين حمام , اتنين سمان مشوي",
      price:"200",
      category:"وجبات"
    },
  ]




